import React from 'react'
import {Container,CartContent,Header,Footer} from 'components'

export default function CartPage(){
  return (
  <>
  <Header/> 
  <Container>
    <CartContent/>
  </Container>
  <Footer/>
 </>
  )
}